
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from '../lib/components/page';
import { PageContent } from '../lib/components/page-content';
import { Heading } from '@aftersale-next/ui';
import { Flex, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from '../lib/hooks/use-translation';
export default function NotFoundPage() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Page, {
    testid: "404-page",
    children: /*#__PURE__*/_jsx(PageContent, {
      children: /*#__PURE__*/_jsx(Flex, {
        direction: "column",
        justify: "center",
        align: "center",
        children: /*#__PURE__*/_jsxs(VStack, {
          spacing: "2",
          children: [/*#__PURE__*/_jsx(Heading, {
            color: "text.primary",
            content: t('surprise_error')
          }), /*#__PURE__*/_jsx(Flex, {
            direction: "column",
            p: "4",
            children: /*#__PURE__*/_jsxs(Text, {
              textAlign: "center",
              color: "text.secondary",
              children: [t('errors.page_not_found'), " ", t('errors.verify_page')]
            })
          })]
        })
      })
    })
  });
}

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/404',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  